import React from 'react';
import { useTranslation } from 'react-i18next';
import StepIcon from './StepIcon';

const ProcessSection = () => {
  const { t } = useTranslation();
  const steps = [1, 2, 3, 4, 5, 6].map((n) => ({
    n,
    label: t(`process.step${n}Label`),
    text: t(`process.step${n}Text`),
  }));

  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center" data-aos="fade-up">
          <span className="eyebrow justify-center">{t('process.subtitle')}</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-ink">{t('process.title')}</h2>
        </div>

        {/* Desktop: horizontal roadmap */}
        <div className="relative mt-16 hidden lg:block">
          <div className="pointer-events-none absolute left-[8.333%] right-[8.333%] top-8 border-t-2 border-dashed border-brand-200" />
          <div className="grid grid-cols-6 gap-6">
            {steps.map((s, i) => (
              <div key={s.n} className="group relative text-center" data-aos="fade-up" data-aos-delay={i * 100}>
                <span className="relative z-10 mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 to-brand-700 text-white shadow-lift ring-8 ring-white transition-transform duration-300 group-hover:-translate-y-1.5">
                  <StepIcon index={s.n - 1} className="h-6 w-6" />
                  <span className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full bg-ink text-[11px] font-bold text-white ring-2 ring-white">{s.n}</span>
                </span>
                <h3 className="mt-5 text-sm font-bold text-ink font-display">{s.label}</h3>
                <p className="mt-2 text-xs leading-relaxed text-slatex-600">{s.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile / tablet: vertical timeline */}
        <ol className="relative mt-12 lg:hidden">
          {steps.map((s, i) => (
            <li key={s.n} className={`relative flex gap-5 ${i === steps.length - 1 ? '' : 'pb-8'}`} data-aos="fade-up" data-aos-delay={i * 60}>
              {i !== steps.length - 1 && (
                <span className="absolute left-7 top-14 bottom-0 w-px border-l-2 border-dashed border-brand-200" aria-hidden="true" />
              )}
              <span className="relative z-10 flex h-14 w-14 flex-none items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 to-brand-700 text-white shadow-soft ring-4 ring-white">
                <StepIcon index={s.n - 1} className="h-6 w-6" />
                <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-ink text-[10px] font-bold text-white ring-2 ring-white">{s.n}</span>
              </span>
              <div className="pt-1.5">
                <h3 className="text-base font-bold text-ink font-display">{s.label}</h3>
                <p className="mt-1 text-sm text-slatex-600">{s.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default ProcessSection;
